<template>
  <VText :cfg="textConfig" color="black">
    {{
      $t('components.campaignFooter.promoNudge', {
        count: missingCuratorsCount,
        missingCuratorsCount,
        discountPercent,
      })
    }}
  </VText>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import VText from '~/components/ui/VText.vue'

import type { PropConfigType } from '~/components/ui/VText.vue'

export default defineComponent({
  components: {
    VText,
  },
  props: {
    missingCuratorsCount: {
      type: Number,
      required: true,
    },
    discountPercent: {
      type: Number,
      required: true,
    },
    isSemibold: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    textConfig(): PropConfigType {
      return this.isSemibold ? 'sans/16/medium' : 'sans/14/medium'
    },
  },
})
</script>
